import i18n from '@/localization/i18n'

export type IDropdownItem = {
  id: number
  label: string
}
export class DropdownItem implements IDropdownItem {
  id: number
  label: string
  constructor(id: number, label: string) {
    this.id = id
    this.label = label
  }
}

export enum CriterionType {
  None = -1,
  Visit = 1,
  Other = 2,
  LandTransport = 3
}

function localize(key: string): string {
  return i18n.global.t(key)
}
export namespace CriterionType {
  export function localized(criterion: CriterionType): string {
    switch (criterion) {
      case CriterionType.None: {
        const loc = i18n.global.t('message.access_permit_type_placeholder')
        return loc
      }
      case CriterionType.Visit: {
        const loc = i18n.global.t('message.access_permit_type_visit')
        return loc
      }

      case CriterionType.LandTransport: {
        const loc = i18n.global.t('message.access_permit_type_land_transport')
        return loc
      }

      case CriterionType.Other: {
        const loc = i18n.global.t('message.access_permit_type_other')
        return loc
      }
      default:
        return ''
    }
  }
  export function toPermit(criterion: CriterionType): string {
    switch (criterion) {
      case CriterionType.Visit: {
        return 'Loading Agreement ID'
      }
      case CriterionType.LandTransport: {
        return 'Maanajolupa ID'
      }
      case CriterionType.Other: {
        return 'Muu lupa'
      }
      default:
        return ''
    }
  }
}

export enum SectionType {
  Permit = 0,
  Form = 1,
  Overview = 2
}

export enum CargoType {
  None = -1,
  Other = 1,
  Timber = 2,
  Container = 3,
  Cardboard = 4
}

export namespace CargoType {
  export function localized(type: CargoType): string {
    switch (type) {
      case CargoType.None:
        // return 'access_permit_request_cargo_placeholder'
        return localize('message.access_permit_request_cargo_placeholder')
      case CargoType.Other:
        return localize('message.access_permit_request_cargo_other')
      case CargoType.Timber:
        return localize('message.access_permit_request_cargo_timber')
      case CargoType.Container:
        return localize('message.access_permit_request_cargo_container')
      case CargoType.Cardboard:
        return localize('message.access_permit_request_cargo_cardboard')
      default:
        return ''
    }
  }
}
